import i18n from './i18n';

if (window.App && (window.App.isUpsell || window.App.topics)) {
    var timerInterval;
    var oldTitle = $(document).find('title').text();
    var newTitle = `${i18n.global.t('tabTitle')}`;

    function intervalJob() {
        document.title = document.title == newTitle ? oldTitle : newTitle;
    }

    $(window)
        .on('focus', function () {
            clearInterval(timerInterval);
            document.title = oldTitle;
        })
        .on('blur', function () {
            timerInterval = setInterval(intervalJob, 1600);
        });
}
